
/*
 |--------------------------------------------------------------------------
 | Laravel Spark Components
 |--------------------------------------------------------------------------
 |
 | Here we will load the Spark components which makes up the core client
 | application. This is also a convenient spot for you to load all of
 | your components that you write while building your applications.
 */

import Vue from 'vue'
import VueResource from 'vue-resource'
import Notifications from 'vue-notification'
import VueDraggable from 'vue-draggable'

// console.log(BaseSurvey.Components)
import BaseSurvey from 'survey-fields'
import bFormSlider from 'vue-bootstrap-slider'
import VTooltip from 'v-tooltip'

if (process.env.NODE_ENV === 'production') {
    Vue.config.devtools = false;
    Vue.config.debug = false;
    Vue.config.silent = true;
}

Vue.use(VTooltip)
Vue.use(VueResource)
Vue.use(Notifications)
Vue.use(VueDraggable)
Vue.use(BaseSurvey)


Vue.http.options.emulateJSON = true

const http=Vue.http
export default http

window.analytics = {
    track: function() {},
    page: function() {}
};

require('./../../../../node_modules/daterangepicker/daterangepicker')

require('./../spark-components/bootstrap')

// VueJS Facebook Signgin button
require('./../../../../node_modules/vue-facebook-signin-button')
import FBSignInButton from 'vue-facebook-signin-button'
Vue.use(FBSignInButton)

// Utility components to be used by other components
require('./utilities')

require('./charts/bar-chart')
require('./charts/horizontal-bar-chart')
require('./charts/doughnut-chart')
require('./charts/pie-chart')
require('./charts/line-chart')
require('./charts/radar-chart')


require('./teams/hotel-picker')

// Home page
import Home from './Home.vue'
Vue.component('home', Home)

// Descriptive term components
require('./descriptive-terms')

// Reviews page
require('./reviews')
import GetHint from './reviews/GetHint.vue';
Vue.component('get-hint',GetHint);
require('./reviews/guestflip-hint')
require('./reviews/response-suggestion');
require('./reviews/edit-response-placeholders')
require('./reviews/promote-reputation')

import EditResponseTemplates from './reviews/EditResponseTemplates'
Vue.component('edit-response-templates',EditResponseTemplates);

// Social - Integration settings
require('./teams/settings/social');
import GoogleSettings from './teams/settings/GoogleSettings.vue'
Vue.component('google-settings', GoogleSettings);

import TeamAudit from './reporting/TeamAudit';
import SurveyAudit from './reporting/SurveyAudit';
Vue.component('team-audit', TeamAudit);
Vue.component('survey-audit', SurveyAudit);

// Social - Integration settings
import TeamIntegrations from './teams/settings/TeamIntegrations'
Vue.component('team-integrations', TeamIntegrations);

import GroupSettings from './groups/settings/GroupSettings.vue'
import GroupIntegrations from './groups/settings/GroupIntegrations.vue'
Vue.component('group-settings', GroupSettings);
Vue.component('group-integrations', GroupIntegrations);

// Early access page
require('./early-access')

// Sugestions page components
require('./suggestions')

import UserPreferences from './preference/UserPreferences';
Vue.component('user-preferences', UserPreferences);

require('./teams/settings/onboarding-create-team');

// Competition page
require('./competition/competition-settings')
require('./competition/competitors')
require('./competition/competition')
require('./competition/competition-table')

// Homepage overview
require('./overview/overview')
require('./overview/source-stat')
require('./overview/average-rating-chart')
require('./overview/sources-pie-chart')
require('./overview/star-distribution-chart')
require('./overview/home-date-picker')
require('./overview/up-down-flag')

// Overview components
require('./overview-components/reviews-count')
require('./overview-components/average-ratings')
require('./overview-components/sentiment-category')

// Groups
require('./groups/group')
require('./groups/group-overview')
require('./groups/group-compare')
import GroupExportModal from "./groups/GroupExportModal"
Vue.component('group-export-modal',GroupExportModal);

require('./groups/group-management');

// Settings
require('./settings/chargebee-payments')

// Generic elements
require('./generic/date-picker')
import ItemButtons from './generic/ItemButtons.vue'
Vue.component('item-buttons', ItemButtons)

// Goals
require('./goals/guestflip-goals')
require('./goals/set-goal')
require('./goals/goal-element')
require('./goals/goal-breakdown')
require('./goals/goal-breakdown-chart')

// Lookups
require('./lookups/tripadvisor-lookup')

require('./onboarding/welcome')
require('./onboarding/first-login-modal')
require('./onboarding/invite-multiple-colleagues')
require('./onboarding/not-loaded')

// Cases section
import Cases from "./cases/Cases.vue";
import CaseCreate from './cases/CaseCreate.vue'
import CaseFilters from './cases/CaseFilters.vue'
import CaseDetails from './cases/CaseDetails.vue'
import CaseSettings from './cases/CaseSettings.vue'
import CasesOverview from "./cases/CasesOverview.vue";
import ArchivedCases from "./cases/ArchivedCases.vue";
Vue.component('cases', Cases)
Vue.component('case-create', CaseCreate)
Vue.component('case-filters', CaseFilters)
Vue.component('case-details', CaseDetails)
Vue.component('cases-settings', CaseSettings)
Vue.component('cases-overview', CasesOverview)
Vue.component('archived-cases', ArchivedCases)

// Surveys section
require('./surveys/surveys-home')
require('./surveys/my-surveys')
require('./surveys/surveys-builder')
require('./surveys/surveys-overview')
require('./surveys/surveys-archives')
require('./surveys/surveys-responses')
require('./surveys/surveys-bookings-upload')

import Loader from "./generic/Loader"
Vue.component('guestflip-fullscreen-loader', Loader)
import TabNavigation from './generic/TabNavigation.vue'
Vue.component('tab-navigation', TabNavigation)

import SurveyItem  from "./surveys/SurveyItem";
import SurveyBookings  from "./surveys/SurveyBookings";
import SurveysCalendar  from "./surveys/SurveysCalendar";
import Pagination from "./generic/Pagination";
import SurveyActions from "./surveys/SurveyActions";
import SurveySingleExport from "./surveys/SurveySingleExport";
import SurveySettings from './surveys/SurveySettings'
import SurveyTranslation from './surveys/SurveyTranslation'
import SurveyImport from './surveys/SurveyImport';
import SurveyStats from './surveys/SurveyStats';
import SurveyStatsBreakdown from './surveys/SurveyStatsBreakdown';

Vue.component('survey-item', SurveyItem)
Vue.component('survey-bookings', SurveyBookings)
Vue.component('surveys-calendar', SurveysCalendar)
Vue.component('survey-actions', SurveyActions)
Vue.component('survey-export-item', SurveySingleExport)
Vue.component('survey-settings', SurveySettings)
Vue.component('survey-translation', SurveyTranslation)
Vue.component('survey-import', SurveyImport)
Vue.component('survey-stats', SurveyStats)
Vue.component('survey-stats-breakdown', SurveyStatsBreakdown)

Vue.component('b-pagination', Pagination)

import InstagramOverview from "./instagram/InstagramOverview"
import InstagramProgress from "./instagram/InstagramProgress"
import InstagramFeedAdv from "./instagram/InstagramFeedAdv"
import InstagramFeed from "./instagram/InstagramFeed"
import InstagramContentSuggestion from "./instagram/InstagramContentSuggestion"
import InstagramPromote from "./instagram/InstagramPromote"
import InstagramWidgetEditor from './instagram/InstagramWidgetEditor'
import InstagramComments from './instagram/InstagramComments'

Vue.component('instagram-overview', InstagramOverview)
Vue.component('instagram-progress', InstagramProgress)
Vue.component('instagram-feed', InstagramFeed)
Vue.component('instagram-feed-adv', InstagramFeedAdv)
Vue.component('instagram-content-suggestion', InstagramContentSuggestion)
Vue.component('instagram-promote', InstagramPromote)
Vue.component('instagram-widget-editor', InstagramWidgetEditor)
Vue.component('instagram-comments', InstagramComments)

import SentimentTrends from "./overview/SentimentTrends"
Vue.component('sentiment-trends', SentimentTrends)

import ReviewEntity from "./reviews/ReviewEntity"
import ExportReviews from "./reviews/ExportReviews"
import ExportReviewsFilters from "./reviews/ExportReviewsFilters"
Vue.component('export-reviews', ExportReviews)
Vue.component('export-reviews-filters', ExportReviewsFilters)

import Reporting from "./reporting/Reporting"
import Suggestions from "./reporting/Suggestions"
import Responses from "./reporting/Responses"
import Segments from "./reporting/Segments"
Vue.component('reporting', Reporting)
Vue.component('suggestions', Suggestions)
Vue.component('responses', Responses)
Vue.component('segments', Segments)

import SentimentEmbed from "./embed/Sentiment"
Vue.component('sentiment-embed', SentimentEmbed)

import Social from "./social/Social"
import SocialStats from "./social/SocialStats"
Vue.component('social', Social)
Vue.component('social-stats', SocialStats)

import TeamPreview from "./onboarding/TeamPreview"
Vue.component('team-preview', TeamPreview)

import ClickHint from "./clickhint/ClickHint"
Vue.component('clickhint', ClickHint)

import FilteredTeamSelector from './admin/FilteredTeamSelector'
import Admin from './admin/Admin'
import Partner from './admin/Partner'
import AdminAddTeams from './admin/AdminAddTeams'
import ManageTeam from './admin/ManageTeam'
Vue.component('filtered-team-selector', FilteredTeamSelector);
Vue.component('gf-admin', Admin);
Vue.component('gf-partner', Partner);

import ShareReviewModal from './modals/ShareReviewModal';
Vue.component('share-review-modal', ShareReviewModal);

import ReviewAlerts from './reviews/ReviewAlerts';
Vue.component('review-alerts', ReviewAlerts);

import GroupReviewAlerts from './groups/GroupReviewAlerts';
Vue.component('group-review-alerts', GroupReviewAlerts);

import Messaging from './messaging/Messaging';
Vue.component('messaging', Messaging);

import Fireworks from "./festive/Fireworks";
Vue.component('fireworks', Fireworks);

import VTagsInput from '@voerro/vue-tagsinput';
Vue.component('tags-input', VTagsInput);

import MarketplacePartners from './marketplace/MarketplacePartners.vue'
Vue.component('marketplace-partners', MarketplacePartners);